<template>
    <div :style="'width:' + width*10/192 + 'vw !important;padding-right:' + padding(width) + 'vw'">
        <div class="smallVideo" @click="$emit('changeVideo',videoList)">
            <div :class="currentIndex == videoList.id ? '' : 'bg'"></div>
            <div class="text">{{videoList.videoName}}</div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "SmallVideo",
        props: ["width", "videoList", "currentIndex"],
        data() {
            return {

            }
        },
     
        methods: {
            padding(value) {
                if (value == 0) {
                    return 0
                } else {
                    return 160 / 192
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .smallVideo {
        // width: 2840/192vw !important;
        height: 1600/108vh !important;
        background: url(../../../assets/img/视频默认封面.png);
        background-size: 100% 100%;
        //padding-right: 160/192vw;
        position: relative;
        cursor: pointer;
        box-sizing: border-box;

        .bg {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
        }

        .text {
            font-size: 18rem;
            color: #FEFEFE;
            position: absolute;
            bottom: 240/108vh;
            left: 240/192vw;
        }
    }
</style>